import styled from 'styled-components';

export const LabelField = styled.label`
    padding: 10px;
    min-width: 50px;
    text-align: right;
`